<template>
  <div class="content">
    <div class="search">
      <el-input
        v-model="keyword"
        @keydown.enter="filter"
        placeholder="请输入uuid"
      ></el-input>
      <div class="m-l-5">
        <el-button @click="filter" type="primary">搜索</el-button>
      </div>
    </div>
    <div class="flex treebox">
      <zm-tree-org
        v-loading="loading"
        ref="tree"
        :data="data"
        :props="props"
        :disabled="disaled"
        :horizontal="horizontal"
        :collapsable="collapsable"
        :label-style="style"
        :node-draggable="true"
        :default-expand-level="1"
        :only-one-node="onlyOneNode"
        :clone-node-drag="cloneNodeDrag"
        :before-drag-end="beforeDragEnd"
        :toolBar="toolBar"
        :define-menus="menus"
        :filterNodeMethod="filterNodeMethod"
        @on-node-drag="nodeDragMove"
        @on-node-drag-end="nodeDragEnd"
        @on-contextmenu="onMenus"
        @on-expand="onExpand"
        @on-node-click="onNodeClick"
        @on-node-dblclick="onNodeDblclick"
        @on-node-copy="onNodeCopy"
      >
        <template v-slot="{ node }">
          <div class="tree_item" :class="id == node.uuid ? 'tree_item_ac' : ''">
            <img
              class="tree_tip"
              src="@/assets/tip1.png"
              v-if="node.vip_point > 2"
            />
            <img
              class="tree_tip"
              src="@/assets/tip2.png"
              v-else-if="node.vip_point > 0"
            />
            <img
              class="tree_tip"
              src="@/assets/tip3.png"
              v-else-if="node.vip_point <= 0"
            />
            <div class="tree_item_box1 xyac">
              {{
                node.username ||
                node.last_name + node.first_name ||
                node.contact ||
                node.label ||
                node.uuid
              }}
            </div>
            <div class="tree_item_box2 xyac">
              {{ node.vip_point || '0' }}pts
            </div>
            <div
              class="tree_item_box3"
              style="padding: 0 1.5rem; font-size: 0.95rem; color: #888"
            >
              <div>UUID: {{ node.uuid }}</div>
              <div>等级: {{ node.vip_level_name || '-' }}</div>
            </div>
          </div>
        </template>
      </zm-tree-org>
      <div class="card" v-if="form.id">
        <el-card>
          <el-form label-position="top" label-width="80px">
            <el-form-item label="用户名称" prop="username">
              {{ form.username ?? '-' }}
            </el-form-item>
            <el-row>
              <el-col :span="8">
                <el-form-item label="名">
                  {{ form.first_name ?? '-' }}
                </el-form-item> </el-col
              ><el-col :span="8">
                <el-form-item label="姓">
                  {{ form.last_name ?? '-' }}
                </el-form-item> </el-col
              ><el-col :span="8">
                <el-form-item label="用户id">
                  {{ form.id ?? '-' }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="公司">
                  {{ form.company ?? '-' }}
                </el-form-item> </el-col
              ><el-col :span="8">
                <el-form-item label="UUID">
                  {{ form.uuid ?? '-' }}
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="联系方式">
              {{ form.contact ?? '-' }}
            </el-form-item>

            <el-row>
              <el-col :span="8">
                <el-form-item label="推荐人id">
                  {{ form.team?.parent?.uuid ?? '-' }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="vip等级">
                  {{ form.team.vip_level_name }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="vip点数">
                  {{ form.vip_point }}
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-form-item label="邀请链接">
              {{ form.invite_url }}
            </el-form-item> -->
            <el-row>
              <el-col :span="8">
                <el-form-item label="当前下级总数">
                  {{ form.team.team_num }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="总下级活跃用户数">
                  {{ form.team.team_active_num }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="下级活跃分组数">
                  {{ form.team.direct_team_active_num }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="10代内下级活跃用户数">
                  {{ form.team.team_10_active_num }}
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-form-item label="邀请码">
              {{ form.invite_code }}
            </el-form-item> -->
            <el-form-item label="推荐QRCode（二维码）">
              <vue-qr :text="form.invite_url" :size="200"></vue-qr>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>

    <el-dialog title="修改上级" :visible.sync="dialogVisible" width="30%">
      <div>
        <div class="m-b-10">
          <span>用户名称:&nbsp;</span>
          <span>{{
            editdata.username || editdata.last_name + editdata.first_name
          }}</span>
        </div>
        <div>
          <div class="m-b-10">
            修改上级:&nbsp;
            <span v-if="selectdata.user_id">{{
              (selectdata.username ||
                selectdata.last_name + selectdata.first_name) +
              '(uuid:' +
              selectdata.uuid +
              ')'
            }}</span>
          </div>
          <el-row>
            <el-col :span="16">
              <el-input
                placeholder="请输入上级uuid"
                v-model="filterText"
                clearable
              >
              </el-input>
            </el-col>
            <el-col :span="4" class="m-l-5">
              <el-button type="primary" @click="searchtarget">搜索</el-button>
            </el-col>
          </el-row>

          <el-row type="flex" class="m-t-10">
            <el-col :span="5" class="text-nowtap">上级用户名</el-col>
          </el-row>
          <el-col>
            <el-tree
              class="filter-tree"
              :data="edittreedata"
              :props="defaultProps"
              @node-click="clicktree"
              default-expand-all
              :filter-node-method="filterNode"
              ref="tree"
            >
            </el-tree>
          </el-col>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="drag">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import request from '@/utils/request'
export default {
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: (data, node) => {
          return (
            (data.username || data.last_name + data.first_name) +
            '(uuid:' +
            data.uuid +
            ')'
          )
        },
      },
      filterText: '',
      dialogVisible: false,
      activeName: 'eidt',
      loading: false,
      toolBar: {
        scale: false,
      },
      keyword: '100001',
      data: {
        username: '暂无数据',
      },
      id: null,
      editdata: {},
      edittreedata: [],
      selectdata: {},
      menus: [{ name: '修改上级', command: 'move' }],
      inviteurl: process.env.VUE_APP_INVITE_URL,
      horizontal: false,
      collapsable: true,
      onlyOneNode: false,
      cloneNodeDrag: false,
      expandAll: true,
      disaled: true,
      selectid: '',
      style: {
        boxShadow: 'none',
        background: 'transparent',
        color: '#5e6d82',
      },
      props: {
        id: 'user_id',
        parent_id: 'parent_id',
        pid: 'parent_id',
        label: 'username',
        expand: 'expand',
        children: 'children',
      },
      form: {
        value: '',
        name: '',
        region: '',
        type: '',
      },
    }
  },
  components: {
    VueQr,
  },
  watch: {
    // filterText(val) {
    //   // this.$refs.tree.filter(val)
    //   request({
    //     url: '/api/backend/team/teamTree',
    //     method: 'get',
    //     params: {
    //       user_id: val,
    //     },
    //   }).then((res) => {
    //     console.log(res)
    //     if (res.code == 0 && !Array.isArray(res.data.tree)) {
    //       this.edittreedata = [res.data.tree]
    //     }
    //   })
    // },
  },
  created() {
    console.log(process.env)

    if (this.$route.query.id) {
      this.keyword = this.$route.query.id
    }
    this.getteamTree()
    // this.toggleExpand(this.data, this.expandAll);
  },
  methods: {
    drag() {
      if (!this.selectdata.uuid) {
        this.$message.error('请选择目标节点')
        return
      }
      request({
        url: '/api/backend/team/changeTeam',
        method: 'post',
        data: {
          uuid: this.editdata.uuid,
          new_parent_uuid: this.selectdata.uuid,
        },
      }).then((res) => {
        console.log(res)
        this.dialogVisible = false
        if (res.code == 0) {
          this.$message.success('移动成功')
          this.selectdata = {}
          this.filterText = ''
        }
        this.getteamTree()
      })
    },
    clicktree(node) {
      console.log(node)
      this.selectdata = node
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    searchtarget() {
      if (!this.filterText) {
        this.$message.error('请输入上级uuid')
        return
      }
      request({
        url: '/api/backend/team/teamTree',
        method: 'get',
        params: {
          uuid: this.filterText,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0 && !Array.isArray(res.data.tree)) {
          this.edittreedata = [{ ...res.data.tree, children: [] }]
          if (this.edittreedata[0].user_id) {
            this.selectdata = this.edittreedata[0]
          }
        }
      })
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    getuserinfo(id) {
      this.form.id = id
      request({
        url: '/api/backend/users/detail',
        method: 'get',
        params: {
          uuid: id,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = res.data
        }
      })
    },
    getteamTree() {
      this.loading = true
      request({
        url: '/api/backend/team/teamTree',
        method: 'get',
        params: {
          uuid: this.keyword,
        },
      }).then((res) => {
        this.loading = false
        console.log(res)
        if (res.code == 0 && !Array.isArray(res.data.tree)) {
          this.data = res.data.tree
        } else {
          this.data = {
            username: '暂无数据',
          }
        }
        this.$nextTick(() => {
          // 修改 .zm-draggable 的 transform 样式
          const draggableEls = document.querySelectorAll('.zm-draggable')
          draggableEls.forEach((el) => {
            el.style.transform = 'translate(0, 17px)'
            this.$forceUpdate()
          })
        })
      })
    },
    onMenus({ node, command }) {
      console.log(node, command)
      if (command == 'move') {
        this.dialogVisible = true
        this.editdata = node
        // request({
        //   url: '/api/backend/team/teamTree',
        //   method: 'get',
        //   params: {
        //     user_id: this.filterText || node.parent_id,
        //   },
        // }).then((res) => {
        //   console.log(res)
        //   if (res.code == 0 && !Array.isArray(res.data.tree)) {
        //     this.edittreedata = [res.data.tree]
        //   }
        // })
      }
    },
    filter() {
      this.getteamTree()
      this.$refs.tree.filter(this.keyword)
    },
    filterNodeMethod(value, data) {
      if (!value) return true
      return String(data?.parent_id).indexOf(value) !== -1
    },
    onExpand(e, data) {
      console.log(e, data)
    },
    nodeDragMove(data) {
      // console.log(data)
    },
    beforeDragEnd(node, targetNode) {
      return new Promise((resolve, reject) => {
        console.log(node, targetNode)
        if (node.parent_id == targetNode.user_id) {
          // this.$message.error('不能移动到当前上级节点')
          return reject()
        }
        if (!targetNode) reject()
        if (node.id === targetNode.id) {
          return reject()
        }
        this.$confirm('是否确认移动节点', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (node.id === targetNode.id) {
              reject()
            } else {
              this.loading = true
              this.form.id = null
              request({
                url: '/api/backend/team/changeTeam',
                method: 'post',
                data: {
                  uuid: node.uuid,
                  new_parent_uuid: targetNode.uuid,
                },
              })
                .then((res) => {
                  this.loading = false
                  // this.getuserinfo(this.selectid)
                  console.log(res)
                  resolve()
                })
                .catch(() => {
                  this.loading = false
                })
            }
          })
          .catch(() => {
            reject()
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      })
    },
    nodeDragEnd(node, targetNode) {
      console.log(node)

      // request({
      //   url: '/api/backend/team/changeTeam',
      //   method: 'post',
      //   data: {
      //     user_id: node.user_id,
      //     new_parent_id: targetNode.user_id,
      //   },
      // }).then((res) => {
      //   this.getuserinfo(this.selectid)
      //   console.log(res)
      // })
    },
    onNodeClick(e, data) {
      console.log(e, data)
      this.id = data.uuid
      this.selectid = data.uuid
      this.form.team_num = data.team_num
      this.getuserinfo(data.uuid)
      //   this.$Message.info(data.label)
    },
    onNodeDblclick() {
      this.$Message.info('双击节点')
    },
    onNodeCopy() {
      this.$Message.success('复制成功')
    },
    handleNodeAdd(node) {
      console.log(node)
      this.$Message.info('新增节点')
    },
    expandChange() {
      this.toggleExpand(this.data, this.expandAll)
    },
    toggleExpand(data, val) {
      if (Array.isArray(data)) {
        data.forEach((item) => {
          this.$set(item, 'expand', val)
          if (item.children) {
            this.toggleExpand(item.children, val)
          }
        })
      } else {
        this.$set(data, 'expand', val)
        if (data.children) {
          this.toggleExpand(data.children, val)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .tree-org-node:not(:first-child):before,
.tree-org-node:not(:last-child):after {
  border-top: 2px solid #ddd;
}
::v-deep .tree-org-node:not(:first-child):before,
::v-deep .tree-org-node:not(:last-child):after {
  border-top: 2px solid #ddd;
}
::v-deep .tree-org-node:after {
  border-left: 2px solid #ddd;
}
::v-deep .tree-org-node__expand {
  // border: 1.5px solid #ccc;
}
::v-deep .tree-org > .tree-org-node:after {
  border-left: 0;
}
::v-deep .tree-org-node__children:before {
  border-left: 2px solid #ddd;
}
::v-deep .collapsable .tree-org-node.collapsed .tree-org-node__content:after {
  border-right: 2px solid #ddd;
}
.content {
  // background: red;
  overflow: hidden;
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  min-height: calc(100vh - 84px);
  padding: 0;
}
.zm-tree-handle {
  bottom: 40px;
}
.search {
  width: 350px;
  display: flex;
  z-index: 8;
  align-items: center;
  position: relative;
  left: 10px;
  padding-top: 10px;
}
.treebox {
  flex: 1;
  position: relative;
  width: 100%;
  height: 100%;
}
.zm-tree-org {
  width: 100%;
  height: auto;
  padding-right: 0;
}
.card {
  // position: absolute;
  // z-index: 999;
  // right: 20px;
  // top: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  width: 655px;
  .el-form-item__content {
    line-height: 16px;
  }
  .el-card {
    overflow-y: scroll;
    height: calc(100vh - 180px);
  }
}
.code {
  width: 300px;
  height: 300px;
}
.select {
  background: #108ffe;
  color: #fff;
}
.tree {
  &_tip {
    position: absolute;
    right: -2px;
    top: -1px;
    width: 1.5rem;
    height: 1.25rem;
  }
  &_item {
    position: relative;
    box-sizing: border-box;
    background: rgba(180, 146, 110, 0.15);
    border-radius: 0.5rem;
    min-width: 8rem;

    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    &_ac {
      border: 2px solid #ffbc76;
    }
    &_box1 {
      box-sizing: border-box;
      width: 100%;
      padding: 0 1.5rem;
      height: 2.75rem;
      font-weight: 600;
      font-size: 1.28rem;
      color: #b4926e;
      line-height: 1.88rem;
      white-space: nowrap;
    }
    &_box2 {
      white-space: nowrap;
      box-sizing: border-box;
      padding: 0 1rem;
      width: 100%;
      height: 2.25rem;
      background: #b4926e;
      font-weight: 600;
      font-size: 1.13rem;
      color: #ffffff;
      line-height: 1.56rem;
    }
    &_box3 {
      box-sizing: border-box;
      width: 100%;
      padding: 0 1.5rem;
      margin: 0.5rem 0;
      font-weight: 500;
      font-size: 0.95rem;
      color: #888;
      line-height: 1.56rem;
      div {
        white-space: nowrap;
      }
    }
  }
}
</style>
